export const CART_ITEM_ADDED = "CART_ITEM_ADDED";
export const FINAL_CART_ITEM_ADDED = "FINAL_CART_ITEM_ADDED";
export const CART_ITEM_CLEARED = "CART_ITEM_CLEARED";
export const CART_ITEM_REMOVED = "CART_ITEM_REMOVED";
export const PRODUCT_ITEM_REMOVED = "PRODUCT_ITEM_REMOVED";
export const PRODUCT_ITEM_UPDATED = "PRODUCT_ITEM_UPDATED";
export const CART_ITEM_RECEIVED = "CART_ITEM_RECEIVED";
export const BOTH_CART_ITEM_RECEIVED = "BOTH_CART_ITEM_RECEIVED";
export const PRODUCT_LIST_RECEIVED = "PRODUCT_LIST_RECEIVED";
export const PRODUCT_CATEGORY_LIST_RECEIVED = "PRODUCT_CATEGORY_LIST_RECEIVED";
export const PROMO_CODE_APPLIED = "PROMO_CODE_APPLIED";
export const CLEAR_PROMO_DETAIL = "CLEAR_PROMO_DETAIL";
